import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { LoadingService } from '../../services/loading.service';
import { IAppSettings } from '../../interfaces/app-settings.model';
import { AppSettings } from '../../app.settings';
import { ProgressBarModule } from 'primeng/progressbar';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { first } from 'rxjs';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [InputTextModule, ButtonModule, DividerModule, CommonModule, ProgressBarModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})

export class LoginComponent implements OnInit {
  settings?: IAppSettings;
  ls = inject(LoadingService);
  formBuilder = inject(FormBuilder);
  route = inject(ActivatedRoute);
  auth = inject(AuthenticationService);
  themeService = inject(ThemeService);
  router = inject(Router);
  
  // loginForm = this.formBuilder.group({
  //   username: ['admin@admin.local', Validators.required],
  //   password: ['admin', Validators.required]
  // });

  loginForm = this.formBuilder.group({
    username: ['', Validators.required],
    password: ['', Validators.required]
  });

  submitted = false;
  loading: boolean = false;
  returnUrl: string = "";

  public errorMessage = "";

  loadingNumber = this.ls.CounterSignal;

  get f() { return this.loginForm.controls; }

  ngOnInit(): void {

    this.settings = AppSettings.settings;
    this.ls.reset();

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';


  }

  onSubmit() {

    this.submitted = true;

    if (this.loginForm.invalid) {
      return;
    }

    if (this.loginForm.controls.username.value && this.loginForm.controls.password.value) {

      this.loading = true;
      this.auth.login(this.loginForm.controls.username.value, this.loginForm.controls.password.value)
        // .pipe(first())
        .subscribe({
          next: (user) => {
            console.log("onsubmit login next");
            console.log(user);
            let startroute: string = AppSettings.settings.startroute;

            if (this.returnUrl != "/") startroute = this.returnUrl;

            localStorage.setItem('defaultTheme', user.userdata.defaultTheme);
            const theme = localStorage.getItem("defaultTheme");
            if (theme) {
              this.themeService.switchTheme(theme); // 
            }

            this.router.navigate(startroute.split("/"));

          },
          error: error => {
            console.log("onsubmit login error", error);
            localStorage.removeItem('auth_token');
            localStorage.removeItem('token');
            localStorage.removeItem('username');
            localStorage.removeItem('userid');
            this.errorMessage = error.error.message;

            this.loading = false;
          }
        });
    }
  }
}
